export const getStorage = (key) => {
  const item = localStorage.getItem(key);
  try {
    return item ? JSON.parse(item) : null;
  } catch {
    return item;
  }
};

export const setStorage = (key, value) => {
  localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
};

export const clearStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearAllStorage = () => {
  localStorage.clear();
};